module.exports = __webpack_public_path__ + "img/write-icon.0c629d36.png";